"use client";

import React from "react";
import Link from "next/link";
import { siteConfig } from "@/config/site.config";

export const FundadorSection: React.FC = () => {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 bg-bg-main border-t border-gold/10 overflow-hidden">
      {/* Luz ambiental sutil */}
      <div className="absolute top-1/2 left-10 -translate-y-1/2 w-80 h-80 bg-gold/5 blur-3xl rounded-full pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
          {/* Columna Izquierda: Retrato o Emblema Personal */}
          <div className="md:col-span-4 flex flex-col items-center text-center">
            <div className="relative w-44 h-44 sm:w-52 sm:h-52 rounded-2xl border border-gold/30 p-2 bg-bg-secondary/40 shadow-2xl flex items-center justify-center group overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-tr from-gold/10 to-transparent pointer-events-none" />
              <div className="w-full h-full rounded-xl border border-gold/20 bg-[#06080e] flex flex-col items-center justify-center p-4">
                <span className="font-serif text-4xl text-gold font-light tracking-wider mb-2">
                  EH
                </span>
                <span className="text-[9px] font-sans tracking-[0.3em] uppercase text-text-muted">
                  Cusco · Perú
                </span>
              </div>
            </div>
            <p className="font-serif text-lg text-text-pure mt-4 font-light">
              {siteConfig.fundador.nombre}
            </p>
            <p className="text-[10px] font-sans tracking-[0.25em] text-gold uppercase mt-0.5">
              {siteConfig.fundador.titulo}
            </p>
          </div>

          {/* Columna Derecha: Texto en Primera Persona */}
          <div className="md:col-span-8 flex flex-col items-start text-left">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-[1px] bg-gold/50" />
              <span className="text-[10px] md:text-xs font-semibold tracking-[0.4em] text-gold uppercase">
                Sobre el Fundador
              </span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl text-text-pure tracking-wide font-light mb-6">
              Pensar con rigor{" "}
              <span className="font-playfair italic text-gold">no debería ser un privilegio</span>
            </h2>

            <blockquote className="border-l-2 border-gold/40 pl-6 my-2">
              <p className="text-text-pure/85 text-base sm:text-lg font-light leading-relaxed tracking-wide">
                &ldquo;{siteConfig.fundador.bioCorta}&rdquo;
              </p>
            </blockquote>

            <div className="mt-8">
              <Link
                href="/nosotros"
                className="inline-flex items-center gap-2 border border-gold/40 bg-gold/5 hover:bg-gold/15 hover:border-gold px-7 py-3 text-xs font-sans text-gold uppercase tracking-[0.2em] rounded transition-all duration-300"
              >
                Conoce el proyecto
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
